var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "checkout-total-group" }, [
    _c("div", { staticClass: "group-head" }, [
      _c(
        "div",
        { staticClass: "group-head__top" },
        [
          _c(
            "div",
            { staticClass: "group-head__wrapper" },
            [
              _c("checkout-label", {
                attrs: {
                  title: "Заказ " + _vm.group.order,
                  type: _vm.group.type
                }
              }),
              _c("span", {
                staticClass: "group-head__title",
                domProps: { innerHTML: _vm._s(_vm.group.title) }
              })
            ],
            1
          ),
          _c("chevron-animated", {
            staticClass: "group-head__chevron",
            attrs: { reverse: _vm.isOpened },
            nativeOn: {
              click: function($event) {
                _vm.isOpened = !_vm.isOpened
              }
            }
          })
        ],
        1
      ),
      _c("div", { staticClass: "group-head__subtitle" }, [
        _vm._v("\n      " + _vm._s(_vm.group.subtitle) + "\n    ")
      ])
    ]),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isOpened,
            expression: "isOpened"
          }
        ],
        staticClass: "dashed-table"
      },
      [
        _c("div", [
          _c("div", [
            _vm._v(
              _vm._s(_vm.group.productsCount) +
                " " +
                _vm._s(
                  _vm._f("decl")(_vm.group.productsCount, "товар", [
                    "",
                    "а",
                    "ов"
                  ])
                ) +
                " на сумму"
            )
          ]),
          _c("div", { staticClass: "price-rub" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm._f("price")(_vm.group.subtotal.productsPrice || 0)) +
                "\n      "
            )
          ])
        ]),
        _c("div", [
          _c("div", [_vm._v("Стоимость доставки")]),
          _c("div", { staticClass: "price-rub" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm._f("price")(_vm.group.subtotal.shippingPrice || 0)) +
                "\n      "
            )
          ])
        ]),
        _vm._l(_vm.group.discounts, function(discount) {
          return _c(
            "div",
            { key: discount.sum, staticClass: "discount accent" },
            [
              _c("div", [_vm._v(_vm._s(discount.name))]),
              _c("div", { staticClass: "price-rub" }, [
                _vm._v(
                  "\n        - " +
                    _vm._s(_vm._f("price")(discount.sum)) +
                    "\n      "
                )
              ])
            ]
          )
        }),
        _vm.group.subtotal.totalPrice
          ? _c("div", { staticClass: "accent" }, [
              _c("div", [_vm._v("Сумма заказа")]),
              _c("div", { staticClass: "price-rub" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm._f("price")(_vm.group.subtotal.totalPrice || 0)
                    ) +
                    "\n      "
                )
              ])
            ])
          : _vm._e()
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }